import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { FileText, Linkedin, MessageSquare, Database, Headphones, Bot, Users } from 'lucide-react';
export const Toolkits = () => {
  const resources = [{
    title: 'LinkedIn Optimization Checklist',
    description: 'Boost your visibility and credibility with a structured guide to optimizing your LinkedIn profile for opportunities.',
    icon: <Linkedin size={36} className="text-primary" data-id="element-4138" />,
    emoji: '🚀'
  }, {
    title: 'Networking Scripts & Templates',
    description: 'Sample outreach messages for introductions, collaborations, and event follow-ups that actually work.',
    icon: <MessageSquare size={36} className="text-primary" data-id="element-4139" />,
    emoji: '🤝'
  }, {
    title: 'Scholarship & Fellowship Database',
    description: 'Curated list of global leadership, fellowship, and funding programs like Chevening, Acumen, and Mandela Washington.',
    icon: <Database size={36} className="text-primary" data-id="element-4140" />,
    emoji: '👍🏽'
  }, {
    title: 'Opportunity Tracker',
    description: 'Stay organized with a shared tracker for grants, fellowships, speaking gigs, and funding opportunities.',
    icon: <FileText size={36} className="text-primary" data-id="element-4141" />,
    emoji: '🌏'
  }, {
    title: 'Pitch Deck Template',
    description: 'A clear, investor-ready deck structure to tell your story and win support.',
    icon: <div size={36} className="text-primary" data-id="element-4142" />,
    emoji: '🚀'
  }, {
    title: 'Podcast Starter List',
    description: 'A curated playlist of podcasts on skills, mindset, leadership, and tools for culture shapers.',
    icon: <Headphones size={36} className="text-primary" data-id="element-4143" />,
    emoji: '🎙'
  }, {
    title: 'AI Tools for Culture Shapers',
    description: 'Handpicked free and freemium AI tools for web/app development, marketing, content, graphics, and presentations.',
    icon: <Bot size={36} className="text-primary" data-id="element-4144" />,
    emoji: '🤖'
  }, {
    title: 'Community Culture Tools',
    description: 'Frameworks and templates to build trust, collaboration, and strong cultural bonds in communities.',
    icon: <Users size={36} className="text-primary" data-id="element-4145" />,
    emoji: '❤️'
  }];
  return <div className="pt-20" data-id="element-4146">
      <section className="py-16 bg-secondary/5" data-id="element-4147">
        <div className="container mx-auto px-4" data-id="element-4148">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4149">
            Community Resources Hub
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-4150">
            Welcome to the Networking Salon Resource Hub — a curated collection
            of tools, templates, and guides designed to help culture shapers,
            leaders, and professionals grow their influence, expand
            opportunities, and strengthen connections. Each resource is
            practical, easy to use, and tailored to support your journey of
            impact and collaboration.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-4151">
        <div className="container mx-auto px-4" data-id="element-4152">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-4153">
            {resources.map((resource, index) => <Card key={index} className="flex flex-col h-full" data-id="element-4154">
                <div className="mb-4 flex items-center" data-id="element-4155">
                  <span className="text-3xl mr-3" data-id="element-4156">{resource.emoji}</span>
                  {resource.icon}
                </div>
                <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-4157">
                  {resource.title}
                </h3>
                <p className="text-secondary mb-6 flex-grow" data-id="element-4158">
                  {resource.description}
                </p>
                <Button variant="outline" className="mt-auto" data-id="element-4159">
                  Access Resource
                </Button>
              </Card>)}
          </div>
          <div className="mt-16 p-8 border border-gray-200 rounded-lg bg-secondary/5" data-id="element-4160">
            <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4161">
              🪪 The Community Directory - Connect with Others
            </h2>
            <p className="text-secondary mb-6" data-id="element-4162">
              A searchable member hub to find peers, discover skills, and
              explore collaboration opportunities.
            </p>
            <Button data-id="element-4163">Access Directory</Button>
          </div>
        </div>
      </section>
    </div>;
};